import React, { Component } from 'react';
import { Redirect } from "react-router";

export class MainRouter extends Component {
    static displayName = MainRouter.name;

    static routeTo;

    constructor(props) {
        super(props);
        this.state = {
            route: '',
            callback: '',
            fromState: null
        };

        MainRouter.routeTo = (to, from, fromState) => {
            const currentLang = window.location.pathname.startsWith('/fr') ? 'fr' : 'en';

            // Automatically add /fr prefix if currently in French mode
            let route = to;
            if (currentLang === 'fr' && !to.startsWith('/fr')) {
                route = '/fr' + (to.startsWith('/') ? to : '/' + to);
            }

            // Optional: if switching languages manually, allow to override prefix
            if (currentLang === 'en' && to.startsWith('/fr')) {
                // fine � user explicitly navigating to /fr
            }

            this.setState({
                route: route,
                callback: from,
                fromState: fromState
            });
        };
    }

    render() {
        if (this.state.route !== '') {
            const { route, callback, fromState } = this.state;

            // Reset route after redirect to avoid infinite redirects
            this.state.route = '';

            return (
                <Redirect
                    to={{
                        pathname: route,
                        state: {
                            fromState: fromState,
                            callback: callback
                        }
                    }}
                />
            );
        }

        return (
            <div className='main-router'>
                {this.props.children}
            </div>
        );
    }
}
